//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_COLORS_YELLOW = {
    color: [
        'var(--ods-yellow-1, #9D6E06)',
        'var(--ods-yellow-2, #B98F11)',
        'var(--ods-yellow-3, #FFB400)',
        'var(--ods-yellow-4, #FFD200)',
        'var(--ods-yellow-5, #FFE45B)',
        'var(--ods-yellow-6, #FFF6B6)',
    ],
};
